// extracted by mini-css-extract-plugin
export var wysiwygCopy__white = "Wysiwyg-module--wysiwygCopy__white--Fm1AG";